<template>
  <div class="hello">
    <img src="@/assets/images/bg01.png"  style="width:100%; height:100%; position:fixed;left:0;top:0;" />
    <div class="dl_logo" style="">
      <a class="logo"><img src="@/assets/images/xinlanlogo.png" /></a>
    </div>
    <div id="fullPage" class="illustrationClass">


      <div id="contentWrapper" class="float">
        <div id="content" style=" position:absolute;background:none;top:60%;">
          <div id="header" style="width:100%;height:128px;background:#ccc;">
            <div class="yhdl" style="width:100%;height:128px;">
              <el-row style="width:100%;z-index:99999999">
                <el-col :span="6"><div class="elhd">{{$t('home.userLogin')}}</div></el-col>
                <el-col :span="8"><div class="elhd"></div></el-col>
                <el-col :span="10">
                  <div class="elhd1">
                    <el-radio-group v-model="entrance" @change="radioChange">
                      <el-radio  label="1" >{{$t('home.cloudPlatform')}}</el-radio>
                    </el-radio-group>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div id="workArea" style="">
            <div id="authArea" class="groupMargin">
              <div id="loginArea">
                <form method="post" id="loginForm" autocomplete="off" novalidate="novalidate" >
                  <div id="formsAuthenticationArea">
                    <div class="list_input" style="">
                      <a class="list_input_a" style=" "><img src="@/assets/images/bg05.png" style="width:40px;z-index:9999" /></a>
                      <div id="userNameArea"  class="list_input_div">
                        <label id="userNameInputLabel" for="userNameInput" class="hidden">用户帐户</label>
                        <input v-model="loginName" id="userNameInput"  type="email" tabindex="1" class="text fullWidth"
                               spellcheck="false" placeholder="someone@example.com" autocomplete="off" />
                      </div>
                    </div>
                    <div class="list_input" style="">
                      <a class="list_input_a" style=""><img src="@/assets/images/bg06.png" style="width:40px;z-index:9999" /></a>
                      <div id="passwordArea" class="list_input_div">
                        <label id="passwordInputLabel" for="passwordInput" class="hidden">密码</label>
                        <input id="passwordInput"  type="password" tabindex="2" class="text fullWidth"
                               v-model="password" placeholder="密码" autocomplete="off"  style=""/>
                      </div>
                    </div>
                    <div class="list_input" style=" position:relative;top:10px;">
                      <a style=" position:absolute;left:0;">{{ $t('home.forgotPassword') }}</a>
                      <div id="kmsiArea" style="position:absolute;right:0;">
                        <input type="checkbox" name="Kmsi" id="kmsiInput" value="true" tabindex="3"  class="kmsiInput_left" style=""/>
                        <label for="kmsiInput">{{ $t('home.rememberMe') }}</label>
                      </div>
                    </div>
                    <div id="submissionArea" class="submitMargin">
                      <!--<input id="submitButton" class="submit" tabindex="4" role="button" type="submit" value="登录" />-->
                      <input @click="login" v-preventReClick class="submit" tabindex="4" role="button" :value="$t('home.login')" />
                    </div>
                    <el-switch
                      v-model="currentLang"
                      active-text="English"
                      active-color="#00FF00"
                      inactive-text="中文"
                      inactive-color="#CD7F32"
                      active-value="en"
                      inactive-value="zh"
                      @change="changeLang">
                    </el-switch>
                  </div>
                  <input id="optionForms" type="hidden" name="AuthMethod" value="FormsAuthentication" />
                </form>
                <div id="introduction" class="groupMargin">
                </div>
              </div>

            </div>

          </div>
          <div id="footerPlaceholder"></div>

          <div class="login_ty" style="width:100%;margin"><img src="@/assets/images/bg07.png" /></div>
        </div>

      </div>

    </div>
<!--            <div class="footer">CopyRight © 2022.沁尔康 All rights reserved.</div>-->

  </div>
</template>

<script>
  export default {
    name: 'login',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        loginName:"",
        password:"",
        entrance:"1",
        currentLang:'zh',// 当前语言
      }
    },
    mounted() {
      if(this.$account.data){
        this.$router.push("/home/equipmentmanagement");
      }
      let temp = localStorage.getItem('languageSet')
      if(temp){
        this.currentLang = temp
      }else{
        this.currentLang = 'zh'
      }
    },
    destroyed() {

    },
    beforeDestroy() {
      document.onkeydown = ''
    },
    created() {
      // 按下回车登录
      var _self = this
      document.onkeydown = function(e) {
        var key = window.event.keyCode
        if (key == 13) {
          _self.login()
        }
      }
    },
    methods:{
      login(){
        if(this.loginName&&this.password){
          let postData = new Object();
          postData.loginName = this.loginName;
          postData.password = this.password;
          let that = this;
          this.$httpservice.post("api/account/LoginAccount",postData).then(
            function (data) {
              if(data.body.code=="200"){
                that.$message({
                  message: that.$t('home.loginSuccessfully'),
                  type: 'success'
                });
                //const accountData = data.body.data;
                //this.Account = JSON.parse(JSON.stringify(data.body.data));
                that.$account.data = data.body.data;
                that.$cookies.set("token", data.body.data.token,{expires: 0});
                let isNeedChangePassword = data.body.data.isNeedChangePassword?"y":"n"
                  sessionStorage.setItem("isNeedChangePassword",isNeedChangePassword)
                  sessionStorage.setItem("loginFlag","2")
                //that.$cookies.set("qingek", 1);
                if(that.entrance == "1"){
                  that.$router.push("/home/equipmentmanagement");

                }else if(that.entrance == "2"){
                  that.$router.push("/largeScreen");
                }
                  console.log(that.entrance)
              }else{
                that.$message({
                  message: data.body.msg,
                  type: 'danger'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode')+statusCode,
                type: 'warning'
              });
            }
          );
        }else{
          this.$message({
            message: '请完善登陆信息',
            type: 'warning'
          });
        }
      },
      radioChange(e){
        console.log(e);
        if(e == "2"){
          this.entrance = "2";
        }
      },
      changeLang(){
        this.$i18n.locale == 'zh'?this.$i18n.locale = 'en':this.$i18n.locale = 'zh'
        localStorage.setItem('languageSet',this.$i18n.locale)
      }

    },
    watch:{
      '$i18n.locale':{
        handler(){
          console.log(this.$i18n.locale)
        },
        deep:true
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  * {
    margin: 0px;
    padding: 0px;
  }

  html {
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    color: #000000;
    font-weight: normal;
    font-family: "Segoe UI Webfont",-apple-system,"Helvetica Neue","Lucida Grande","Roboto","Ebrima","Nirmala UI","Gadugi","Segoe Xbox Symbol","Segoe UI Symbol","Meiryo UI","Khmer UI","Tunga","Lao UI","Raavi","Iskoola Pota","Latha","Leelawadee","Microsoft YaHei UI","Microsoft JhengHei UI","Malgun Gothic","Estrangelo Edessa","Microsoft Himalaya","Microsoft New Tai Lue","Microsoft PhagsPa","Microsoft Tai Le","Microsoft Yi Baiti","Mongolian Baiti","MV Boli","Myanmar Text","Cambria Math";
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }


  #noScript {
    margin: 16px;
    color: Black;
  }

  :lang(en-GB) {
    quotes: '\2018' '\2019' '\201C' '\201D';
  }

  :lang(zh) {
    font-family: 微软雅黑;
  }

  @-ms-viewport {
    width: device-width;
  }

  @-moz-viewport {
    width: device-width;
  }

  @-o-viewport {
    width: device-width;
  }

  @-webkit-viewport {
    width: device-width;
  }

  @viewport {
    width: device-width;
  }

  /* Theme layout styles */

  #fullPage {
    position: absolute;
    bottom: 28px;
    top: 0px;
    width: 100%;
  }

  #brandingWrapper {
    background-color: #4488dd;
    height: 100%;
    width: 100%;
  }

  #branding {
    /* A background image will be added to the #branding element at run-time once the illustration image is configured in the theme.
       Recommended image dimensions: 1420x1200 pixels, JPG or PNG, 200 kB average, 500 kB maximum. */
    background-color: inherit;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
  }

  #contentWrapper {
    background-color: transparent;
    height: 0px;
    width: 100%;
  }

  #content {
    /* Set content to center */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: #fff;

    /* Set size margins */
    margin-bottom: 28px;
    margin-left: auto;
    margin-right: auto;
    min-height: 290px;


    height: auto;
    width:36%;margin:0 auto;

    /* Add drop shadow */
    box-sizing:border-box;
    border:1px solid transparent;
    background-clip:padding-box,border-box;
    background-origin:padding-box,border-box;
    border-image:linear-gradient(to top,rgba(47,92,154,0),#2f5c9a) 1 10;
  }

  #header {
    font-size: 2em;
    font-weight: lighter;
    font-family: "Segoe UI Webfont",-apple-system,"Helvetica Neue","Lucida Grande","Roboto","Ebrima","Nirmala UI","Gadugi","Segoe Xbox Symbol","Segoe UI Symbol","Meiryo UI","Khmer UI","Tunga","Lao UI","Raavi","Iskoola Pota","Latha","Leelawadee","Microsoft YaHei UI","Microsoft JhengHei UI","Malgun Gothic","Estrangelo Edessa","Microsoft Himalaya","Microsoft New Tai Lue","Microsoft PhagsPa","Microsoft Tai Le","Microsoft Yi Baiti","Mongolian Baiti","MV Boli","Myanmar Text","Cambria Math";
    padding: 0px 0px 0px 0px;
    margin: 0px;
    height: 24px;
    width: 338px;
    background-color: transparent;
  }

  #header img {
    /* Logo image recommended dimension: 108x24  or 338x24 (elongated), 4 kB average, 10 kB maximum. Transparent PNG strongly recommended. */
    width: auto;
    height: 100%;
    position: relative;
    top: -7px;
  }

  #loginMessage {
    box-sizing: border-box;
    color: rgb(38, 38, 38);
    direction: ltr;
    display: block;
    font-family: "Segoe UI Webfont", -apple-system, "Helvetica Neue", "Lucida Grande", Roboto, Ebrima, "Nirmala UI", Gadugi, "Segoe Xbox Symbol", "Segoe UI Symbol", "Meiryo UI", "Khmer UI", Tunga, "Lao UI", Raavi, "Iskoola Pota", Latha, Leelawadee, "Microsoft YaHei UI", "Microsoft JhengHei UI", "Malgun Gothic", "Estrangelo Edessa", "Microsoft Himalaya", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Tai Le", "Microsoft Yi Baiti", "Mongolian Baiti", "MV Boli", "Myanmar Text", "Cambria Math";
    font-weight: 300;
    font-size: 1.2rem;
    height: auto;
    line-height: 28px;
    margin-bottom: 16px;
    margin-left: -2px;
    margin-right: -2px;
    margin-top: 16px;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    text-align: left;
    text-size-adjust: 100%;
    width: 342px;
    background-color: transparent;
  }

  #loginForm {
    /*width: 338px;*/
  }

  #workArea, #header {
    word-wrap: break-word;
    width: 100%;
  }

  #workArea {
    margin-bottom: 90px;
    margin-top: 16px;
    background-color: transparent;
    margin:0 auto;
    border:solid 1px #fff;
    width:100%;background:#fff;padding:20px 0;

  }

  #footerPlaceholder {
    height: 0px;
  }

  #footer {
    background-color: rgba(0, 0, 0, 0.6);
    bottom: 0px;
    box-sizing: border-box;
    clear: both;
    color: rgb(38, 38, 38);
    direction: ltr;
    display: block;
    filter: none;
    font-family: "Segoe UI Webfont", -apple-system, "Helvetica Neue", "Lucida Grande", Roboto, Ebrima, "Nirmala UI", Gadugi, "Segoe Xbox Symbol", "Segoe UI Symbol", "Meiryo UI", "Khmer UI", Tunga, "Lao UI", Raavi, "Iskoola Pota", Latha, Leelawadee, "Microsoft YaHei UI", "Microsoft JhengHei UI", "Malgun Gothic", "Estrangelo Edessa", "Microsoft Himalaya", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Tai Le", "Microsoft Yi Baiti", "Mongolian Baiti", "MV Boli", "Myanmar Text", "Cambria Math";
    font-size: 15px;
    font-weight: normal;
    height: 28px;
    line-height: 20px;
    overflow-x: visible;
    overflow-y: visible;
    position: fixed;
    text-align: center;
    text-size-adjust: 100%;
    width: 100%;
  }

  #footerLinks {
    padding-left: 10px;
  }

  #copyright {
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    direction: ltr;
    display: inline-block;
    font-family: "Segoe UI Webfont", -apple-system, "Helvetica Neue", "Lucida Grande", Roboto, Ebrima, "Nirmala UI", Gadugi, "Segoe Xbox Symbol", "Segoe UI Symbol", "Meiryo UI", "Khmer UI", Tunga, "Lao UI", Raavi, "Iskoola Pota", Latha, Leelawadee, "Microsoft YaHei UI", "Microsoft JhengHei UI", "Malgun Gothic", "Estrangelo Edessa", "Microsoft Himalaya", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Tai Le", "Microsoft Yi Baiti", "Mongolian Baiti", "MV Boli", "Myanmar Text", "Cambria Math";
    font-size: 12px;
    font-weight: normal;
    height: 28px;
    line-height: 28px;
    margin-left: 8px;
    margin-right: 8px;
    text-align: left;
    text-size-adjust: 100%;
  }

  #userNameArea, #passwordArea {
    box-sizing: border-box;
    color: rgb(38, 38, 38);
    direction: ltr;
    display: block;
    font-family: "Segoe UI Webfont", -apple-system, "Helvetica Neue", "Lucida Grande", Roboto, Ebrima, "Nirmala UI", Gadugi, "Segoe Xbox Symbol", "Segoe UI Symbol", "Meiryo UI", "Khmer UI", Tunga, "Lao UI", Raavi, "Iskoola Pota", Latha, Leelawadee, "Microsoft YaHei UI", "Microsoft JhengHei UI", "Malgun Gothic", "Estrangelo Edessa", "Microsoft Himalaya", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Tai Le", "Microsoft Yi Baiti", "Mongolian Baiti", "MV Boli", "Myanmar Text", "Cambria Math";
    font-size: 15px;
    font-weight: normal;
    height: 52px;
    line-height: 20px;
    margin-left: 0px;
    margin-right: -2px;
    text-align: left;
    text-size-adjust: 100%;

  }

  #updatePasswordForm #submitButton, #cancelButton {
    width: 48%;
  }

  #oldPasswordArea, #newPasswordArea {
    margin-bottom: 7px;
  }

  #errorMessage{
    margin-top: 5px;
  }

  .pageLink {
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
    color: rgb(0, 0, 0);
    direction: ltr;
    display: inline-block;
    font-family: "Segoe UI Webfont", -apple-system, "Helvetica Neue", "Lucida Grande", Roboto, Ebrima, "Nirmala UI", Gadugi, "Segoe Xbox Symbol", "Segoe UI Symbol", "Meiryo UI", "Khmer UI", Tunga, "Lao UI", Raavi, "Iskoola Pota", Latha, Leelawadee, "Microsoft YaHei UI", "Microsoft JhengHei UI", "Malgun Gothic", "Estrangelo Edessa", "Microsoft Himalaya", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Tai Le", "Microsoft Yi Baiti", "Mongolian Baiti", "MV Boli", "Myanmar Text", "Cambria Math";
    font-size: 12px;
    font-weight: normal;
    height: 28px;
    line-height: 28px;
    margin-left: 0px;
    margin-right: 0px;
    text-align: left;
    text-size-adjust: 100%;
    text-decoration: underline;
  }

  /* Common content styles */

  .clear {
    clear: both;
  }

  .float {
    float: left;
  }

  .floatReverse {
    float: right;
  }

  .indent {
    margin-left: 16px;
  }

  .indentNonCollapsible {
    padding-left: 16px;
  }

  .hidden {
    display: none;
  }

  .notHidden {
    display: inherit;
  }

  .error {
    color: #e81123;
  }

  .actionLink {
    margin-top: 5px;
    margin-bottom: 8px;
    display: block;
  }

  a {
    color: #0067b8;
    text-decoration: none;
    background-color: transparent;
    word-wrap: normal;
  }

  ul {
    list-style-type: disc;
  }

  ul, ol, dd {
    padding: 0 0 0 16px;
  }

  h1, h2, h3, h4, h5, label {
    margin-bottom: 8px;
  }

  .submitMargin {
    margin-top: 18px;
    margin-bottom: 18px;
  }

  .topFieldMargin {
    margin-top: 8px;
  }

  .fieldMargin {
    margin-bottom: 8px;
  }

  .groupMargin {
    margin-bottom: 0px;width:60%;margin:0 auto;
  }

  .sectionMargin {
    margin-bottom: 64px;
  }

  .block {
    display: block;
  }

  .autoWidth {
    width: auto;
  }

  .fullWidth {
    width: 342px;
  }

  .fullWidthIndent {
    width: 326px;
  }

  .smallTopSpacing {
    margin-top: 15px;
  }

  .mediumTopSpacing {
    margin-top: 25px;
  }

  .largeTopSpacing {
    margin-top: 35px;
  }

  .smallBottomSpacing {
    margin-bottom: 5px;
  }

  .mediumBottomSpacing {
    margin-bottom: 15px;
  }

  .largeBottomSpacing {
    margin-bottom: 25px;
  }

  #openingMessage {
    margin-bottom: 4px;
  }

  input {
    max-width: 100%;
    font-family: inherit;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  input[type="radio"], input[type="checkbox"] {
    vertical-align: middle;
    margin-bottom: 0px;
  }

  input.submit, input[type="submit"] {
    align-items: flex-start;
    background: #ab1a1d;

    box-sizing: border-box;
    color: rgb(255, 255, 255);
    cursor: pointer;
    direction: ltr;
    display: inline-block;
    font-family: "Segoe UI Webfont", -apple-system, "Helvetica Neue", "Lucida Grande", Roboto, Ebrima, "Nirmala UI", Gadugi, "Segoe Xbox Symbol", "Segoe UI Symbol", "Meiryo UI", "Khmer UI", Tunga, "Lao UI", Raavi, "Iskoola Pota", Latha, Leelawadee, "Microsoft YaHei UI", "Microsoft JhengHei UI", "Malgun Gothic", "Estrangelo Edessa", "Microsoft Himalaya", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Tai Le", "Microsoft Yi Baiti", "Mongolian Baiti", "MV Boli", "Myanmar Text", "Cambria Math";
    font-stretch: normal;
    font-style: normal;
    font-variant-caps: normal;
    font-variant-ligatures: normal;
    font-variant-numeric: normal;
    font-weight: normal;
    height: 52px;
    letter-spacing:5px;
    line-height:52px;
    margin-bottom: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    max-width: 100%;
    min-width: 165px;
    overflow-x: hidden;
    overflow-y: hidden;
    text-align:center; letter-spacing:5px;font-size:22px;
    position: relative;
    text-align: center;
    text-indent: 0px;
    text-overflow: ellipsis;
    text-rendering: auto;
    text-shadow: none;
    text-size-adjust: 100%;
    touch-action: manipulation;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    width: 100%;
    word-spacing: 0px;
    writing-mode: horizontal-tb;
    -webkit-appearance: none;
    -webkit-rtl-ordering: logical;
    -webkit-border-image: none;
    border:none; border-radius:5px; outline:none;
  }

  input[type="submit"]:hover, input.submit:hover {
    background: #ab1a1d;
  }

  input.text {
    background-color: rgba(255, 255, 255, 0.4);
    background-image: none;
    border-bottom-color: rgba(0, 0, 0, 0.6);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-image-outset: 0px;
    border-image-repeat: stretch;
    border-image-slice: 100%;
    border-image-source: none;
    border-image-width: 1;
    border-left-color: rgba(0, 0, 0, 0.6);
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: rgba(0, 0, 0, 0.6);
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: rgba(0, 0, 0, 0.6);
    border-top-style: solid;
    border-top-width: 1px;
    box-sizing: border-box;
    color: rgb(38, 38, 38);
    cursor: auto;
    direction: ltr;
    display: block;
    font-family: "Segoe UI Webfont", -apple-system, "Helvetica Neue", "Lucida Grande", Roboto, Ebrima, "Nirmala UI", Gadugi, "Segoe Xbox Symbol", "Segoe UI Symbol", "Meiryo UI", "Khmer UI", Tunga, "Lao UI", Raavi, "Iskoola Pota", Latha, Leelawadee, "Microsoft YaHei UI", "Microsoft JhengHei UI", "Malgun Gothic", "Estrangelo Edessa", "Microsoft Himalaya", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Tai Le", "Microsoft Yi Baiti", "Mongolian Baiti", "MV Boli", "Myanmar Text", "Cambria Math";
    font-size: 15px;
    font-stretch: normal;
    font-style: normal;
    font-variant-caps: normal;
    font-variant-ligatures: normal;
    font-variant-numeric: normal;
    font-weight: normal;
    height: 36px;
    letter-spacing: normal;
    line-height: 20px;
    margin-bottom: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    max-width: 100%;
    outline-color: rgb(38, 38, 38);
    outline-style: none;
    outline-width: 0px;
    padding-bottom: 6px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 6px;
    text-align: start;
    text-indent: 0px;
    text-rendering: auto;
    text-shadow: none;
    text-size-adjust: 100%;
    text-transform: none;
    user-select: text;
    width: 338px;
    word-spacing: 0px;
    writing-mode: horizontal-tb;
    -webkit-appearance: none;
    -webkit-locale: "en";
    -webkit-rtl-ordering: logical;
    -webkit-border-image: none;
  }

  input.text:focus {
    border: 1px solid #6B6B6B;
  }

  select {
    height: 28px;
    min-width: 60px;
    max-width: 100%;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    box-shadow: none;
    padding: 2px;
    font-family: inherit;
  }

  h1, .giantText {
    font-size: 2.0em;
    font-weight: lighter;
  }

  h2, .bigText {
    font-size: 1.33em;
    font-weight: lighter;
  }

  h3, .normalText {
    font-size: 1.0em;
    font-weight: normal;
  }

  h4, .smallText {
    font-size: 0.9em;
    font-weight: normal;
  }

  h4 {
    font-size: 0.7em;
    font-weight: normal;
  }

  h5, .tinyText {
    font-size: 0.8em;
    font-weight: normal;
  }

  .hint {
    color: #999999;
  }

  .emphasis {
    font-weight: 700;
    color: #2F2F2F;
  }

  .smallIcon {
    height: 20px;
    padding-right: 12px;
    vertical-align: middle;
  }

  .largeIcon {
    height: 48px;
    /* width:48px; */
    vertical-align: middle;
  }

  .largeTextNoWrap {
    height: 48px;
    display: table-cell; /* needed when in float*/
    vertical-align: middle;
    white-space: nowrap;
    font-size: 1.2em;
  }

  .idp {
    height: 48px;
    clear: both;
    padding: 8px;
    overflow: hidden;
    cursor: pointer;
  }

  .idp:hover {
    background-color: #cccccc;
    cursor: pointer;
  }

  .idpDescription {
    width: 80%;
    cursor: pointer;
  }

  .identityBanner{
    color: black;
    background: #F2F2F2;
    text-align: right;
    white-space: nowrap;
    line-height: 28px;
    height: 28px;
    width: calc(100% - 57px);
    margin-left: -36px;
    padding-right: 117px;
    font-family: "Segoe UI Webfont",-apple-system,"Helvetica Neue","Lucida Grande","Roboto","Ebrima","Nirmala UI","Gadugi","Segoe Xbox Symbol","Segoe UI Symbol","Meiryo UI","Khmer UI","Tunga","Lao UI","Raavi","Iskoola Pota","Latha","Leelawadee","Microsoft YaHei UI","Microsoft JhengHei UI","Malgun Gothic","Estrangelo Edessa","Microsoft Himalaya","Microsoft New Tai Lue","Microsoft PhagsPa","Microsoft Tai Le","Microsoft Yi Baiti","Mongolian Baiti","MV Boli","Myanmar Text","Cambria Math";
    font-size: 16px;
    font-weight: 400;
  }

  .submit.backButton{
    color: black;
    width: 165px;
    float: left;
    background: #CCCCCC;
    border-color: #CCCCCC;
    margin-left: -2px;
  }

  .submit.nextButton{
    margin-left: -2px;
  }

  .identityBannerImage {
    position: relative;
    float: right;
    top: -48px;
    left: -33px;
  }

  .submitMargin.submitModified {
    margin-bottom: 60px;
  }

  .submit.modifiedSignIn{
    display: block;
    width: auto;
    float: right;
  }

  #submissionArea{
    margin-top: 8px;
  }

  /* HoloLens Customization */
  body.htmlBodyHolo, html.htmlBodyHolo {
    height: 100%;
    width: 100%;
    background-color: rgb(160, 160, 160);
    color: #000000;
    font-weight: normal;
    font-family: "Segoe UI Webfont",-apple-system,"Helvetica Neue","Lucida Grande","Roboto","Ebrima","Nirmala UI","Gadugi","Segoe Xbox Symbol","Segoe UI Symbol","Meiryo UI","Khmer UI","Tunga","Lao UI","Raavi","Iskoola Pota","Latha","Leelawadee","Microsoft YaHei UI","Microsoft JhengHei UI","Malgun Gothic","Estrangelo Edessa","Microsoft Himalaya","Microsoft New Tai Lue","Microsoft PhagsPa","Microsoft Tai Le","Microsoft Yi Baiti","Mongolian Baiti","MV Boli","Myanmar Text","Cambria Math";
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }

  #loginForm.loginFormHolo{
    width: 750px;
  }

  #content.contentHolo {
    margin-bottom: 28px;
    margin-left: auto;
    margin-right: auto;

    max-width: 765px;
    width: 338px;
    height: auto;
    padding: 36px;
    padding-top:0px;

    margin:0px;
    font-weight: light;
    font-size: 20px;

    min-height:none;
    min-width:none;

    max-width: 765px;
    width: 864px;
    transform: none;
    position:relative;
    top:auto;
    left: auto;
    background-color: unset;
    box-shadow:unset;
    border:unset;
  }

  #kmsiArea.kmsiAreaHolo{
    margin-top: 20px;
  }

  #companyLogo.companyLogoHolo{
    padding-right: 360px;
    height: 23px;
    position: unset;
    top: unset;
  }

  #contentWrapper.contentWrapperHolo{
    background-color: rgb(160, 160, 160);
  }

  #brandingWrapper.brandingWrapperHolo{
    display: none;
  }

  #footer.footerHolo{
    display: none;
  }

  #header.headerHolo{
    padding: 0px;
    display: inline-block;
    width: 100%;
    margin-bottom: 0px;
    height: 0px;
    min-height: 0px;
    font-size: 46px;
    color: rgb(0, 120, 215);
  }

  #hololens_passwordNote{
    color: rgb(0, 0, 0);
    font-family: "Segoe UI", "Segoe", "SegoeUI-Regular-final", Tahoma, Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    margin:0px;
    overflow-wrap: break-word;
    padding:0px;
    width:512px;
  }

  #hololens_signinTitle{
    font-size: 30px;
  }

  #userNameArea.userNamePasswordAreaHolo, #passwordArea.userNamePasswordAreaHolo {
    color: rgb(0, 0, 0);
    font-family: "Segoe UI", "Segoe", "SegoeUI-Regular-final", Tahoma, Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    overflow-wrap: break-word;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    width: 100%;
  }

  #passwordInput.passwordInputHolo {
    background-color: rgb(210, 210, 210);
    border-bottom-color: rgb(0, 120, 215);
    border-bottom-style: solid;
    border-bottom-width: 4px;
    border-image-outset: 0;
    border-image-repeat: stretch stretch;
    border-image-slice: 100%;
    border-image-source: none;
    border-image-width: 1;
    border-left-color: rgb(0, 120, 215);
    border-left-style: solid;
    border-left-width: 4px;
    border-right-color: rgb(0, 120, 215);
    border-right-style: solid;
    border-right-width: 4px;
    border-top-color: rgb(0, 120, 215);
    border-top-style: solid;
    border-top-width: 4px;
    color: rgb(0, 0, 0);
    font-family: "Segoe UI", "Segoe", "SegoeUI-Regular-final", Tahoma, Helvetica, Arial, sans-serif;
    font-size: 28px;
    font-weight: 400;
    height: 60px;
    margin-bottom: 8px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    max-width: 100%;
    overflow-wrap: break-word;
    width: 512px;
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    padding: 6px 10px;
  }

  #submitButton.submitButtonHolo{
    background-color: rgb(0, 120, 215);
    border-bottom-color: rgb(255, 255, 255);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-image-outset: 0;
    border-image-repeat: stretch stretch;
    border-image-slice: 100%;
    border-image-source: none;
    border-image-width: 1;
    border-left-color: rgb(255, 255, 255);
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: rgb(255, 255, 255);
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: rgb(255, 255, 255);
    border-top-style: solid;
    border-top-width: 1px;
    bottom: 48px;
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: block;
    font-family: "Segoe UI Light", "Segoe", "SegoeUI-Light-final", Tahoma, Helvetica, Arial, sans-serif;
    font-size: 30px;
    font-weight: 400;
    height: 63px;
    margin-bottom: 8px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    min-width: 80px;
    overflow-wrap: break-word;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px;
    position: absolute;
    right: 289px;
    top: 253px;
    text-align: center;
    transition-delay: 0s;
    transition-duration: 0s;
    transition-property: background;
    transition-timing-function: ease;
    width: 240px;
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    -moz-user-select: none;
  }

    .footer{
      position:absolute;
      right:0;
      bottom:0;
      left:0;
      height: 50px;
      color: #ffffff;
    }

  /*@media (max-width: 600px), (max-height: 392px){*/
  /*    #content {*/
  /*        !* Set content to center *!*/
  /*        position: relative;*/
  /*        top: 0;*/
  /*        left: 0;*/
  /*        transform: none;*/
  /*        background-color: #fff;*/
  /*        !* Set size margins *!*/
  /*        margin-bottom: 28px;*/
  /*        margin-left: auto;*/
  /*        margin-right: auto;*/
  /*        min-height: 290px;*/
  /*        min-width: 320px;*/
  /*        max-width: 412px;*/
  /*        width: calc(100% - 40px);*/
  /*        height: auto;*/
  /*        padding: 23px 18px 0px 18px;*/
  /*        !* Add drop shadow *!*/
  /*        box-shadow: 0 0 0 rgba(0,0,0,0);*/
  /*        border: 0px solid rgba(0,0,0,0);*/
  /*    }*/

  /*    #footer {*/
  /*        background-color: rgba(255,255,255);*/
  /*        bottom: 0px;*/
  /*        box-sizing: border-box;*/
  /*        clear: both;*/
  /*        color: rgb(38, 38, 38);*/
  /*        direction: ltr;*/
  /*        display: block;*/
  /*        filter: none;*/
  /*        font-family: "Segoe UI Webfont", -apple-system, "Helvetica Neue", "Lucida Grande", Roboto, Ebrima, "Nirmala UI", Gadugi, "Segoe Xbox Symbol", "Segoe UI Symbol", "Meiryo UI", "Khmer UI", Tunga, "Lao UI", Raavi, "Iskoola Pota", Latha, Leelawadee, "Microsoft YaHei UI", "Microsoft JhengHei UI", "Malgun Gothic", "Estrangelo Edessa", "Microsoft Himalaya", "Microsoft New Tai Lue", "Microsoft PhagsPa", "Microsoft Tai Le", "Microsoft Yi Baiti", "Mongolian Baiti", "MV Boli", "Myanmar Text", "Cambria Math";*/
  /*        font-size: 15px;*/
  /*        font-weight: normal;*/
  /*        height: 28px;*/
  /*        line-height: 20px;*/
  /*        overflow-x: visible;*/
  /*        overflow-y: visible;*/
  /*        position: fixed;*/
  /*        text-align: left;*/
  /*        text-size-adjust: 100%;*/
  /*        width: 100%;*/
  /*    }*/

  /*    #brandingWrapper {*/
  /*        display: none;*/
  /*    }*/

  /*    #copyright{*/
  /*        color:rgb(0,0,0);*/
  /*    }*/
  /*}*/

  /* Targets displays using any of Windows’ High Contrast Mode themes: */
  @media screen and (-ms-high-contrast: active) {
    textarea::-webkit-input-placeholder {
      color: #00FF00;
    }

    textarea:-moz-placeholder { /* Firefox 18- */
      color: #00FF00;
    }

    textarea::-moz-placeholder { /* Firefox 19+ */
      color: #00FF00;
    }

    textarea:-ms-input-placeholder {
      color: #00FF00;
    }
  }

  /* Targets displays using the Windows’ "High Contrast Black" theme: */
  @media screen and (-ms-high-contrast: white-on-black) {
    #contentWrapper {
      background-color: #000000;
      color: #ffffff;
    }
    .idp:hover {
      background-color: #ffffff;
      color: #000000;
    }
    #brandingWrapper {
      background-color: #000000;
      color: #ffffff;
    }

    textarea::-webkit-input-placeholder {
      color: #ffffff;
    }

    textarea:-moz-placeholder { /* Firefox 18- */
      color: #ffffff;
    }

    textarea::-moz-placeholder { /* Firefox 19+ */
      color: #ffffff;
    }

    textarea:-ms-input-placeholder {
      color: #ffffff;
    }
  }

  /* Targets displays using the Windows’ "High Contrast White" theme: */
  @media screen and (-ms-high-contrast: black-on-white) {
    #contentWrapper {
      background-color: #ffffff;
      color: #000000;
    }

    .idp:hover {
      background-color: #000000;
      color: #ffffff;
    }

    #brandingWrapper {
      background-color: #ffffff;
      color: #000000;
    }


    textarea::-webkit-input-placeholder {
      color: #000000;
    }

    textarea:-moz-placeholder { /* Firefox 18- */
      color: #000000;
    }

    textarea::-moz-placeholder { /* Firefox 19+ */
      color: #000000;
    }

    textarea:-ms-input-placeholder {
      color: #000000;
    }
  }

  #mfaGreetingDescription{
    margin-bottom:30px;
  }
  .kmsiInput_left{width: 16px;
    height: 16px;
    position: relative;top:-2px;
    right: 10px; border-radius:3px;
    border: solid 1px #c5c5c5;}

  .dl_logo{ width:100%;height:80px;margin:0 auto; }
  .dl_logo .logo{ display:inline-block;width:40%; position:absolute;top:5%;left:5%;}
  .dl_logo .logo img{width:70%;}

  .yhdl{
    height:128px;
    width:100%;
    background:url('../assets/images/bg08.png');
    background-size: 100% 100%;
  }
  .yhdl .yhdl_a1{ display:inline-block;width:100%;font-size:30px;color:#fff;line-height:128px; letter-spacing:2px;margin-left:20px; text-align:left;z-index:10000 !important; position:relative;top:-128px;}
  .yhdl .yhdl_a2{ display:inline-block;height:128px; position:relative;top:7px;}
  .yhdl .yhdl_a2 img{ width:100%;height:128px;}

  .elhd{
    display:inline-block;width:100%;font-size:30px;
    color:#fff;line-height:128px;
    letter-spacing:2px;margin-left:20px;
    text-align:left;
    z-index:10000 !important;
    position:relative;
  }

  .elhd1{
    display:inline-block;width:100%;font-size:20px;
    color:#fff;line-height:128px;
    letter-spacing:2px;margin-left:20px;
    text-align:left;
    z-index:10000 !important;
    position:relative;
  }

  .list_input{ width:100%; overflow:hidden;height:50px;margin:10px 0px;}

  .list_input_a{display:block;float:left;width:40px;font-size:16px;}
  .list_input label,a{font-size:16px;}
  .list_input_a img{width:40px; position:relative;top:3px;}
  .list_input_div{display:block;float:left;width:100%;position:relative;top:-42px;border:none;}
  .list_input_div input{font-size:16px;color:#333; border:solid 1px #c5c5c5 !important; padding:5px 0px 8px 50px;width:100%;height:40px; }
  .list_input_div input.text{height:47px;}


  .login_ty{width:36%;margin:0 auto;}
  .login_ty img{width:100%;margin:0 auto; position:relative;top:-1px;height:100%;}
</style>



// WEBPACK FOOTER //
// src/pages/loginxl.vue